function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3152",
  "data-name": "Group 3152"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_3151",
  "data-name": "Group 3151"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_428",
  "data-name": "Path 428",
  d: "M22.2,0A22.2,22.2,0,1,0,44.4,22.2,22.225,22.225,0,0,0,22.2,0Zm0,42.47A20.27,20.27,0,1,1,42.47,22.2,20.292,20.292,0,0,1,22.2,42.47Z",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_429",
  "data-name": "Path 429",
  d: "M102.052,131.026a3.026,3.026,0,1,0-3.026,3.026A3.03,3.03,0,0,0,102.052,131.026Zm-4.035,0a1.009,1.009,0,1,1,1.009,1.009A1.01,1.01,0,0,1,98.017,131.026Z",
  transform: "translate(-84.496 -112.661)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_430",
  "data-name": "Path 430",
  d: "M227.026,128a3.026,3.026,0,1,0,3.026,3.026A3.03,3.03,0,0,0,227.026,128Zm0,4.035a1.009,1.009,0,1,1,1.009-1.009A1.01,1.01,0,0,1,227.026,132.035Z",
  transform: "translate(-197.156 -112.661)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_431",
  "data-name": "Path 431",
  d: "M123.837,224.257a1.008,1.008,0,0,0-1.424.079,11.222,11.222,0,0,1-16.653,0,1.009,1.009,0,0,0-1.5,1.346,13.239,13.239,0,0,0,19.659,0A1.009,1.009,0,0,0,123.837,224.257Z",
  transform: "translate(-91.887 -197.156)",
  fill: "#ac1ede"
})));

var SvgSmile = function SvgSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "smile",
    width: 44.4,
    height: 44.4,
    viewBox: "0 0 44.4 44.4",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smile.8c901c43.svg";
export { ForwardRef as ReactComponent };